(function() {

  angular.module('clientDashboardApp.common').directive('notes', Notes);

  function Notes() {

    return {
      restrict: 'A',
      template:
        "<div class='modal fade' id='confirmDeleteNoteModal' tabindex='-1' role='dialog' aria-labelledby='myModalLabel' aria-hidden='true'>\
          <div class='modal-dialog'>\
            <div class='modal-content'>\
              <div class='modal-body'>\
                <h4>Confirm Delete Note?</h4>\
              </div>\
              <div class='modal-footer'>\
                <button type='button' class='btn btn-outline-secondary' data-dismiss='modal' ng-click='resetDeleteTarget()'>Cancel</button>\
                <button type='button' class='btn btn-secondary' data-dismiss='modal' ng-click='deleteNote()'>\
                Delete\
                </button>\
              </div>\
            </div>\
          </div>\
        </div>",
      scope: {
        entityData: "=",
        noteSettings: '=',
        nestedEntityKey: "@"
      },
      controller: NotesController
    }
  }

  NotesController.$inject = ['$scope','noteService','$sanitize'];

  function NotesController($scope,noteService,$sanitize) {

    $scope.deleteNote = function(){
      var deleteTarget = noteService.getDeleteTarget();
      var entity = deleteTarget.entity;
      var note = deleteTarget.note;
      noteService.deleteNote(note._id).then(function(){
        $scope.reloadNotes(entity,$scope.noteSettings.noteType);
        noteService.resetDeleteTarget();
      });
    }

    $scope.reloadNotes = function(entity,type){
      var idArray = [entity[$scope.noteSettings.idKey]];
      noteService.getNotes(idArray, type).then(function(data){
        entity.notes = data;
        _.each(entity.notes,function(e){
          e.noteDetail = noteService.processAsHtml(e.noteDetail);
        });
      });
    }

    function getNotesForResults(entityData) {
      var entityIds = [];
      var nestedIds = [];

      for(var x in entityData){
        entityIds.push(entityData[x][$scope.noteSettings.idKey]);

        //get ids for nested content
        if(entityData[x][$scope.nestedEntityKey]){
          _.each(entityData[x][$scope.nestedEntityKey],function(item){
            nestedIds.push(item[$scope.noteSettings.idKey]);
          });
        }
      }

      entityIds = _.union(entityIds,nestedIds);

      noteService.getNotes(entityIds, $scope.noteSettings.noteType).then(function(data){
        //var nestedEntityKey = _.where(data,function(item){return _.contains(nestedIds,item.entityId);});
        populateItemsWithNotes(data,$scope.entityData);
      })
    };

    function populateItemsWithNotes(noteData,entityData){
      var notesAsHTML = noteData;
      _.each(notesAsHTML,function(item){
        item.noteDetail = noteService.processAsHtml(item.noteDetail);
      });

      _.each(entityData,function(item){
        var tempNotes = _.filter(notesAsHTML,function(itemToFilter){
          return itemToFilter.entityId == item[$scope.noteSettings.idKey];
        });
        item.notes = tempNotes;
        if(item[$scope.nestedEntityKey]){
          populateItemsWithNotes(noteData,item[$scope.nestedEntityKey]);
        }
      });
    }

    getNotesForResults($scope.entityData);

    $scope.$watch('noteSettings.ready', function(newVal,oldVal){
      if(newVal !== oldVal && newVal > 0){ // noteSettings.ready can be true/false, or just incremented everytime a refresh is needed
                                           // conveniently true > 0 === true
        getNotesForResults($scope.entityData);
      }
    })

  }
})();
